var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSkydomeIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 158 161",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00f5ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0 78a64 64 0 0 1 1.72-12.5c6.96-32.8 33.1-59.5 65.6-64.6a78.6 78.6 0 0 1 8.36-0.79c2.15-0.06 4.3-0.06 5.79-0.06 1.19 0 1.89 0 3.61 0.13 0.79 0.06 1.79 0.16 1.87 0.17a40.9 40.9 0 0 1 6.42 0.94c29.3 6.19 49.2 23.7 60 52 0.38 1 0.46 1.4-0.85 1.39q-15.3-0.06-30.6 0a2 2 0 0 1-1.92-1.08 46.6 46.6 0 0 0-3.33-4.64c-12.3-14.5-27.8-20.6-46.3-17.2-17.9 3.33-30.1 14.2-36.8 31.5-0.71 1.82-0.63 1.86 1.3 1.86h45.5q37.3 0 74.6 0c1 0 1.66 0 1.9 1.44a80.7 80.7 0 0 1-6.35 47.9c-15.2 33-50.3 51.6-85.4 44.9-26.2-5-45.1-20.2-57.1-44.5a47.5 47.5 0 0 1-3.42-8.87h1.81 29.6a2.64 2.64 0 0 1 2.58 1.44 48.1 48.1 0 0 0 81 0.37 46.7 46.7 0 0 0 5.77-12.2h-2q-59.7 0-119 0a2.6 2.6 0 0 1-1.82-0.46 2.47 2.47 0 0 1-0.7-1.71c-0.38-1.92-0.44-2.39-0.92-5.27-0.2-2-0.33-3.45-0.41-5-0.11-1.19-0.11-2.78-0.11-4.66"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkydomeIconBlue);
export default __webpack_public_path__ + "static/media/skydome-icon-blue.a5e462153bd8d13e9af436768d47365d.svg";
export { ForwardRef as ReactComponent };